import { render, staticRenderFns } from "./supplierdeposit_details.vue?vue&type=template&id=cf6a1fca&"
import script from "./supplierdeposit_details.vue?vue&type=script&lang=js&"
export * from "./supplierdeposit_details.vue?vue&type=script&lang=js&"
import style0 from "./supplierdeposit_details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports